export default "__VITE_ASSET__932ec4ad__"